var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EpbLegend',{attrs:{"items":_vm.items,"show-labels":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }